var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowH(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8993 11.5725L18.068 8.08028C17.9616 7.99383 17.8452 7.97719 17.7188 8.03041C17.5925 8.08371 17.5291 8.18009 17.5291 8.31985V10.5549H5.07709C4.98392 10.5549 4.90739 10.5847 4.84759 10.6446C4.78783 10.7044 4.75781 10.781 4.75781 10.8741V12.7897C4.75781 12.8828 4.78769 12.9593 4.84756 13.0191C4.90749 13.0789 4.98403 13.1088 5.07706 13.1088H17.5292V15.3438C17.5292 15.477 17.5927 15.5734 17.7189 15.6331C17.8454 15.6865 17.9618 15.6663 18.0682 15.5734L21.8996 12.041C21.9661 11.9746 21.9992 11.8949 21.9992 11.8017C21.9992 11.7154 21.9659 11.639 21.8993 11.5725Z",
    fill: "#303238"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.48242 10.5533H6.46979V8.31835C6.46979 8.18512 6.40623 8.08873 6.27995 8.02906C6.15346 7.9756 6.03707 7.99581 5.93079 8.08873L2.09946 11.6211C2.06873 11.6517 2.04516 11.6851 2.02874 11.7214C2.00938 11.7638 1.9997 11.8101 1.9997 11.8604C1.9997 11.9467 2.03316 12.0231 2.09967 12.0896L5.931 15.5818C6.03729 15.6683 6.15367 15.6849 6.28016 15.6317C6.40644 15.5784 6.46979 15.482 6.46979 15.3422V13.1072H6.48242L6.48242 10.5533Z",
    fill: "#303238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowH);
export default __webpack_public_path__ + "static/media/arrow-h.e739fa9f82d8dd43ddbad7f915ab9f8b.svg";
export { ForwardRef as ReactComponent };